export default __webpack_public_path__ + "static/media/General_Resources.b83c102b.png";